// packages
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import Cookies from 'js-cookie';
import { ref } from '@vue/composition-api';

Pusher.logToConsole = true;

/**
 * Iniciação do websocket.
 * Criação da conecção entre o lado do cliente e API
 * através de sockets.
 *
 * @since 1.1.0
 * @category Função
 * @autor Tiago Martinho
 *
*/
const initConnection = () => {
    const isConnected = ref( false );

    // definição das configurações para a ligação.
    const socket = new Echo({
        broadcaster: 'pusher',
        key: process.env.VUE_APP_SOCKET_KEY,
        wsHost: process.env.VUE_APP_SOCKET_URL,
        wssHost: process.env.VUE_APP_SOCKET_URL,
        cluster: 'mt1',
        wsPort: process.env.VUE_APP_SOCKET_PORT,
        wssPort: process.env.VUE_APP_SOCKET_PORT,
        forceTLS: process.env.VUE_APP_SOCKET_SCHEMA === 'https',
        disableStats: true,
        enabledTransports: [ 'ws', 'wss' ],
        authEndpoint: `${process.env.VUE_APP_SOCKET_SCHEMA}://${process.env.VUE_APP_SOCKET_AUTH_URL}`,
        encrypted: process.env.VUE_APP_SOCKET_SCHEMA === 'https',
        auth: {
            headers: {
                Authorization: `Bearer ${Cookies.get( 'token' )}`,
                Accept: 'Application/json',
                'Access-Control-Allow-Origin': `${process.env.VUE_APP_SOCKET_SCHEMA}://${process.env.VUE_APP_SOCKET_URL}`
            }
        }
    });

    socket.connector.pusher.connection
        .bind( 'connected', () => {
            isConnected.value = true;
        })
        .bind( 'unavailable', () => {
            console.log( 'unavailable' );
        })
        .bind( 'error', () => {
            console.log( 'error' );
        })
        .bind( 'failed', () => {
            console.log( 'error' );
        })
        .bind( 'disconnected', () => {
            console.log( 'disconnect' );
        });

    return { socket, isConnected };
};

export default initConnection;